<template>
  <Modal
    v-model="showError"
    title="Sorry! An error has occurred."
    :append-to-body="true"
    @hide="onClose"
    :footer="false">
    <p>An error has occurred accessing the On Demand Training. Our Support team has been notified of the issue. To get training now, check out our webinars <a :href="webinars" target="_blank">here.</a></p>
  </Modal>
</template>

<script>
import { toolkitUrls } from '../links'
import Modal from '@/components/A11yModal'

export default {
  name: 'OnDemandTrainingErrorModal',
  components: {
    Modal
  },
  data() {
    return {
      showError: false,
      webinars: toolkitUrls.webinars
    }
  },
  props: {
    showErrorModal: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      required: true
    }
  },
  watch: {
    showErrorModal(newValue) {
      this.showError = newValue
    }
  }
}
</script>
